import {
  FormFieldConfigType,
  INPUT_TYPES,
  TEXT_INPUT_TYPES,
  SelectFormField,
  TextInputFormField,
} from "../../../../types";
import { BUSINESS_DETAILS_CONSTANTS } from "../../../constants";
import { preProcessFormFields } from "../../../../tools";
import {
  BUSINESS_UNIT_OPTIONS,
  COUNTRY_OPTIONS,
  VERTICAL_OPTIONS,
} from "../../../options";
import { SelectProps } from "@amzn/awsui-components-console";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: "allBusinessDetailsFields",
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: "Business Details",
    fields: [
      {
        name: BUSINESS_DETAILS_CONSTANTS.BUSINESS_UNIT,
        label: "Business Unit",
        description: "",
        placeholderText: "Select business unit",
        type: INPUT_TYPES.SELECT,
        options: BUSINESS_UNIT_OPTIONS,
        onChange: (
          { detail }: { detail: SelectProps.ChangeDetail },
          formState,
          updateForm
        ) => {
          const isSupplyChainLossPrevention =
            detail.selectedOption.value ===
            BUSINESS_UNIT_OPTIONS.find((option: SelectProps.Option) =>
              option.label?.includes("Supply Chain Loss Prevention")
            )?.value;
          updateForm({
            ...formState,
            [BUSINESS_DETAILS_CONSTANTS.BUSINESS_UNIT]: {
              ...formState[BUSINESS_DETAILS_CONSTANTS.BUSINESS_UNIT],
              value: detail.selectedOption,
            },
            [BUSINESS_DETAILS_CONSTANTS.VERTICAL]: {
              ...formState[BUSINESS_DETAILS_CONSTANTS.VERTICAL],
              hidden: !isSupplyChainLossPrevention,
            },
          });
        },
      } as SelectFormField,
      {
        name: BUSINESS_DETAILS_CONSTANTS.VERTICAL,
        label: "Vertical",
        description: "",
        placeholderText: "Select vertical",
        type: INPUT_TYPES.SELECT,
        options: VERTICAL_OPTIONS,
      } as SelectFormField,
      {
        name: BUSINESS_DETAILS_CONSTANTS.COMPANY_NAME,
        label: "Company Name",
        description: "",
        placeholderText: "Enter company name",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      } as TextInputFormField,
      {
        name: BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_DETAILS,
        label: BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_DETAILS,
        description: "",
        placeholderText: "",
        hasPopover: false,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        columns: 2,
        fields: [
          {
            name: BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_NAME,
            label: "Point of Contact Name",
            description: "",
            placeholderText: "Enter point of contact name",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_EMAIL_ADDRESS,
            label: "Point of Contact Email Address",
            description: "",
            placeholderText: "Enter point of contact email address",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.EMAIL,
          } as TextInputFormField,
        ],
      },

      {
        name: BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESSES,
        label: BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESSES,
        description: "",
        placeholderText: "",
        hasPopover: false,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        columns: 2,
        fields: [
          {
            name: BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESS_0,
            label: "Additional Contact Email (Supplier/Shipper)",
            description: "",
            placeholderText: "Enter additional contact email addresses",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.EMAIL,
          } as TextInputFormField,
          {
            name: BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESS_1,
            label: "Additional Contact Email (Supplier/Shipper)",
            description: "",
            placeholderText: "Enter additional contact email addresses",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.EMAIL,
          } as TextInputFormField,
        ],
      },
      {
        name: BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS,
        label: "Company Address",
        header: "Company Address",
        description: "",
        placeholderText: "",
        hasPopover: false,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: true,
        fields: [
          {
            name: BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_LINE_1,
            label: "Address Line 1",
            description: "",
            placeholderText: "Enter Address Line 1",
            hasPopover: false,
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_LINE_2,
            label: "Address Line 2",
            description: "",
            placeholderText: "Enter Address Line 2",
            hasPopover: false,
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_CITY,
            label: "City",
            description: "",
            placeholderText: "Enter City",
            hasPopover: false,
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_STATE,
            label: "State/Province",
            description: "",
            placeholderText: "Enter State/Province",
            hasPopover: false,
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_ZIP_CODE,
            label: "Postal Code",
            description: "",
            placeholderText: "Enter Postal Code",
            errors: [],
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: BUSINESS_DETAILS_CONSTANTS.COUNTRY_ID,
            label: "Country",
            description: "",
            placeholderText: "Select country",
            type: INPUT_TYPES.SELECT,
            options: COUNTRY_OPTIONS,
          } as SelectFormField,
        ],
      },
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
